import pay from './pay'

export const payPromise = pay
